














import { defineComponent, onMounted, computed } from '@vue/composition-api';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { TP_HOME_ADVANTAGE_LIST_EXPOSE } from '@/pages/home/tianqi';
import { useMaxQuotaText } from '@/shared/utils/getMaxQuota';

const maxQuotaText = useMaxQuotaText();

const advantageList = computed(() => [
  {
    icon: 'circle',
    title: '循环额度',
    desc: `最高${maxQuotaText.value}额度`,
  },
  {
    icon: 'light',
    title: '快速放款',
    desc: '30秒放款',
  },
  {
    icon: 'profession',
    title: '专业合规',
    desc: '息费透明',
  },
]);

export default defineComponent({
  name: 'AdvantageList',
  setup() {
    onMounted(() => {
      ubtSetupModuleExpose(TP_HOME_ADVANTAGE_LIST_EXPOSE);
    });

    return {
      advantageList,
    };
  },
});
